import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

import Login from '@/pages/Login';
import Dispatch from '@/pages/Dispatch';
import Users from '@/pages/Users';
import Clients from '@/pages/Clients';
import Locations from '@/pages/Locations';
import Visits from '@/pages/Visits';
import Timesheets from '@/pages/Timesheets';
import CleanerDashboard from '@/pages/CleanerDashboard';
import RecurringJobs from '@/pages/RecurringJobs';

const HomePage = () => {
  const { user } = useAuth();
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  if (user.role === 'CLEANER') {
    return <Navigate to="/cleaner" replace />;
  }
  
  return <Navigate to="/dispatch" replace />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<HomePage />} />
          
          <Route
            path="/dispatch"
            element={
              <ProtectedRoute allowedRoles={['ADMIN', 'MANAGER']}>
                <Dispatch />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute allowedRoles={['ADMIN', 'MANAGER']}>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clients"
            element={
              <ProtectedRoute allowedRoles={['ADMIN', 'MANAGER']}>
                <Clients />
              </ProtectedRoute>
            }
          />
          <Route
            path="/locations"
            element={
              <ProtectedRoute allowedRoles={['ADMIN', 'MANAGER']}>
                <Locations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/visits"
            element={
              <ProtectedRoute allowedRoles={['ADMIN', 'MANAGER']}>
                <Visits />
              </ProtectedRoute>
            }
          />
          <Route
            path="/timesheets"
            element={
              <ProtectedRoute allowedRoles={['ADMIN', 'MANAGER']}>
                <Timesheets />
              </ProtectedRoute>
            }
          />
          <Route
            path="/recurring-jobs"
            element={
              <ProtectedRoute allowedRoles={['ADMIN', 'MANAGER']}>
                <RecurringJobs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cleaner"
            element={
              <ProtectedRoute allowedRoles={['CLEANER']}>
                <CleanerDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
